import http from "./http";
import {useRequest} from "ahooks";
import {isEmptyObj} from "../utils";

let apiPath = {
  qryReserveInfoPageForPc: '/item/shopItemReserveInfo/qryReserveInfoPageForPc',
  getDetailInfo: '/item/shopItemReserveInfo/getDetailInfo'
};

/**
 * 获取预约项目列表
 * @param query
 * @returns {{result: unknown, getBooking: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useQryReserveInfoPageForPc = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.qryReserveInfoPageForPc,
      method: 'get',
      data: q || {}
    });
  }, {
    manual: true,
  });
  
  return {
    result: data || {},
    loading,
    error,
    getBooking: runAsync
  };
};


export const useGetDetailInfo = (query) => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.getDetailInfo,
      method: 'get',
      data: query || q || {}
    });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    getDetail: runAsync
  };
};
